import { render, staticRenderFns } from "./OperaProjectRatioWindow.vue?vue&type=template&id=e8befb9a&"
import script from "./OperaProjectRatioWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectRatioWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports